<template>
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
  >
    <path
      d="M22.832132,25.749247l-.431362-.031844c-.960004-.070873-1.736493-.809568-1.855144-1.764842l-.626731-5.045997c-.149623-1.204657.789895-2.268085,2.003807-2.268085h1.058093c1.115176,0,2.019204.904029,2.019204,2.019203v5.077841c0,1.173739-.997315,2.100141-2.167868,2.013725Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M16.991406,25.749247v-.031844c-.960004-.070873-1.736493-.809568-1.855144-1.764842l-.626731-5.045997c-.149623-1.204657.789895-2.268085,2.003807-2.268085h1.058093c1.115176,0,2.019204.904029,2.019204,2.019203l-.275988,5.077841c0,1.173739-1.152689,2.100141-2.323242,2.013725Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M12.003203,25.38586l-.443818-.029302c-.883376-.065217-1.29836-.744946-1.407538-1.623972l-.082796-4.643224c-.010796-1.336829,1.076353-2.087045,1.657256-2.087045h.973636c1.026162,0,1.85803.831868,1.85803,1.85803l-.90108,4.67253c-.413981,1.146956-.576572,1.932506-1.653692,1.852986l.000002-.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M10.024989,18.633462l-1.060055,3.010234c-.426729.89009-2.244294,1.777369-2.244294,1.777369-.637596-.138941-.456311-.541678-.440126-1.266022l.033164-.284232.411197-3.490542c.07759-.311051.303267-.651003.721523-.915491.20243-.128362.449286-.238391.746216-.319497l1.112952-.201018c.749039.100157.830865.856237.719422,1.689195v.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M7.446399,17.464777c-.418257.264488-.643933.60444-.721523.915491l-.411197,3.490542c-.585388.807569-2.106024,1.550254-2.106024,1.550254-.637596-.138941-.456346-.541678-.440126-1.266022l.225711-1.912073.169989-1.441633c.112132-.449992.562107-1.557314,1.421177-1.701905.022558-.003523.045838-.007042.069119-.009161l1.131997.007757c.347003-.024686.551569.121309.660877.366753v-.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M5.584408,17.099429c-.859071.14459-1.309046,1.251913-1.421177,1.701905l-.169989,1.441633c-.584699.41472-1.613724.655933-1.613724.655933-.433789-.200311-.241208-.455623-.117091-.964151l.404137-1.159523.400624-1.147521c.154457-.308217.670726-1.048079,1.330191-.971204l.806862.186201c.201018.030324.32021.12272.380168.256724v.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M25,32.680753c-1.64249,1.531732-3.284982,0-8.256848,0s-13.894588-3.104866-15.181946-4.305413,0-7.865658,0-7.865658c0,0,.188968-1.734723,1.105548-1.734723"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M27.167867,25.749247l.43136-.031844c.960004-.070873,1.736495-.809568,1.855142-1.764842l.626733-5.045997c.149623-1.204657-.789897-2.268085-2.003806-2.268085h-1.058093c-1.115174,0-2.019204.904029-2.019204,2.019203v5.077841c0,1.173739.997313,2.100141,2.167868,2.013725Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M33.008593,25.749247v-.031844c.960004-.070873,1.736495-.809568,1.855142-1.764842l.626733-5.045997c.149623-1.204657-.789897-2.268085-2.003806-2.268085h-1.058093c-1.115174,0-2.019203.904029-2.019203,2.019203l.275986,5.077841c0,1.173739,1.152689,2.100141,2.32324,2.013725Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M37.996798,25.38586l.443818-.029302c.883376-.065217,1.298359-.744946,1.407538-1.623972l.082798-4.643224c.010795-1.336829-1.076353-2.087045-1.657256-2.087045h-.973636c-1.026162,0-1.85803.831868-1.85803,1.85803l.901082,4.67253c.413983,1.146956.576571,1.932506,1.65369,1.852986l-.000004-.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M43.279282,23.421065s-1.817532-.887275-2.244261-1.777369l-1.060055-3.010234c-.111444-.832959-.029616-1.589042.719389-1.689195l1.112986.201018c.29693.081102.543785.191135.746182.319497.418257.264488.643968.60444.721558.915491l.411164,3.490542.033164.284232c.016221.724348.19747,1.127081-.440124,1.266022l-.000004-.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M45.792301,23.421065s-1.520638-.742685-2.10606-1.550254l-.411164-3.490542c-.07759-.311051-.303301-.651003-.721558-.915491.109344-.245444.313873-.391438.660879-.366753l1.13203-.007757c.023245.002119.046527.005638.069119.009161.859037.14459,1.309011,1.251913,1.421867,1.701905l.169991,1.441633.224989,1.912073c.016221.724348.19747,1.127081-.440091,1.266022v.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M47.621131,20.898899s-1.029024-.241217-1.613724-.655933l-.169991-1.441633c-.112855-.449992-.562829-1.557314-1.421867-1.701905.059921-.134.179148-.2264.380133-.256724l.806895-.186201c.659431-.076876,1.176423.662986,1.330192.971204l.400625,1.147521.404104,1.159523c.12415.508528.316696.76384-.116367.964151v-.000004Z"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
    <path
      d="M25,32.680753c1.64249,1.531732,3.284984,0,8.256848,0s13.894586-3.104866,15.181946-4.305413c1.287356-1.200547,0-7.865658,0-7.865658,0,0-.188969-1.734723-1.10555-1.734723"
      style="
        fill: none;
        stroke: #333f48;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.030065px;
      "
    />
  </svg>
</template>

<script>
export default {
  name: "LowerArch"
}
</script>
